"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.targetIsOrContainedByEl = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

function isElement(element) {
  return element instanceof Element || element instanceof HTMLDocument;
}

var targetIsOrContainedByEl = function targetIsOrContainedByEl(selector, target) {
  if (!isElement(target)) {
    return false;
  }

  if (target.classList.contains(selector)) {
    return true;
  }

  return (0, _toConsumableArray2.default)(document.querySelectorAll(selector)).reduce(function (acc, el) {
    return acc || el && el.contains(target);
  }, false);
};

exports.targetIsOrContainedByEl = targetIsOrContainedByEl;